export interface GameConfig {
  name: string
  dailyTitle: string;
  commonThing: string;
  thing: string;
  title: string
  dataSource: 'soccer' | 'roster' | 'running'
  storagePrefix: string
  theme: {
    primaryColor: string
    secondaryColor: string
    icon: string
    sport: string
  }
}

const soccerConfig: GameConfig = {
  name: 'guessFC',
  commonThing: "club",
  thing: "player",
  title: 'Guess FC',
  dailyTitle: "football",
  dataSource: 'soccer',
  storagePrefix: 'guessfc',
  theme: {
    primaryColor: '#4CAF50',
    secondaryColor: '#45a049',
    icon: '⚽',
    sport: 'soccer'
  }
}

const rosterConfig: GameConfig = {
  name: 'rosterGuess',
  commonThing: "franchise",
  dailyTitle: "NFL",
  thing: "player",
  title: 'Roster Guess',
  dataSource: 'roster',
  storagePrefix: 'rosterguess',
  theme: {
    primaryColor: '#FF6B35',
    secondaryColor: '#E55A2B',
    icon: '🏈',
    sport: 'football'
  }
}

const runsConfig: GameConfig = {
  name: '5runs',
  thing: "parkrun",
  dailyTitle: "parkrun",
  commonThing: "region",
  title: '5 runs',
  dataSource: 'running',
  storagePrefix: '5runs',
  theme: {
    primaryColor: '#ffeb35ff',
    secondaryColor: '#e5d22bff',
    icon: '🏃‍➡️',
    sport: 'running'
  }
}

// Get game configuration based on build-time environment variable
export function getGameConfig(): GameConfig {
  const gameType = import.meta.env.VITE_GAME_TYPE || 'soccer'
  
  switch (gameType) {
    case 'roster':
      return rosterConfig
    case 'running':
      return runsConfig
    case 'soccer':
    default:
      return soccerConfig
  }
}

export const gameConfig = getGameConfig()
